import Api from '@/services/api.service';
<template>
    <v-card flat>
        <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12" sm="12" md="12">
                        <v-select
                        v-model="curLevel"
                        :items="levels"
                        item-text="name_level"
                        item-value="id"
                        label="Nível do usuário"
                        v-on:change="save()"
                        ></v-select>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>


<script>
import Api from "../../services/api.service";
import { mapMutations } from "vuex";

export default {
  name: 'Level',
  props: {
    selectedItem: {
        type: Object,
        required: true,
    },
  },
  data: () => ({
    is_email_confirmed: null,
    levels: [],
    curLevel: null
  }),
  mounted () {
      Api.get('/users/'+this.selectedItem.id+'/level')
        .then((response) => {
            console.log(response.data);
            this.curLevel = response.data.id;
        });
      Api.get(`levels`)
              .then((response) => {
                  this.levels = response.data;
                  console.log(this.levels);
              })
              .catch(() => {

                this.isLoading = false;
              });
  },
  methods: { 
    ...mapMutations(["showSnackbar"]),
      save() {
          console.log(this.curLevel);
          let data = {
              level: this.curLevel
          };
        Api.put('/users/'+this.selectedItem.id+'/change-level', data).then((response) => {
            if(response.data) {
                this.showSnackbar({
                  text: "Nível atualizado com sucesso!",
                  color: "success",
                });
            }
        });
      }
  }
}
</script>
